<!-- LIQUIDACIÓN · POR RESOLVER (NOP-01 a 04). Sin diálogos: retener se confirma en la página, con motivo. -->
<div class="flex flex-col gap-[24px]">
  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
  </div>
  <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status">
    <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span>
  </div>
  <!-- 6.1b: los cobros de la cobranza retenidos por la salud de los cobros, antes de pagarlos. -->
  <app-liquidacion-salud-cobros class="block" [dia]="dia"></app-liquidacion-salud-cobros>

  <p class="kb-hint" *ngIf="cargando">Buscando los pagos no procesados…</p>

  <div class="kb-empty" *ngIf="!cargando && !pagos.length">
    <span class="kb-empty-icono"><i class="fas fa-check" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No hay pagos por resolver</p>
    <p class="kb-empty-texto">Aquí aparece lo que el banco no pudo pagar. Lo retenido hoy vuelve a aparecer mañana.</p>
  </div>

  <!-- LOT-16: el banco pagó algo de un lote que ya se había anulado. -->
  <section class="kb-card" *ngIf="pagadosTrasAnular.length">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-exclamation-triangle text-muted-foreground" aria-hidden="true"></i>Pagados después de anular · {{ pagadosTrasAnular.length }}</h2>
        <p class="kb-card-desc">El banco procesó estos pagos aunque su lote se anuló. Revisa si se pagaron también por otro lado antes de registrarlos; si el banco los reversó, descártalos con el motivo.</p>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="flex flex-col gap-[12px] border-t border-border px-[24px] py-[16px]" *ngFor="let p of pagadosTrasAnular">
        <div class="flex flex-wrap items-start justify-between gap-[12px]">
          <div class="min-w-0">
            <p class="m-0 inline-flex flex-wrap items-center gap-x-2 font-medium"><app-estampa-comercio [codigo]="p.merchant_code" [tam]="24"></app-estampa-comercio><span class="kb-td-mono">{{ p.code }}</span> · {{ p.merchant_code }} · $ {{ p.monto | number:'1.2-2':'es' }}</p>
            <p class="m-0 text-sm text-muted-foreground">Pagado por el banco en
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm !w-auto !h-auto !p-0 !text-muted-foreground underline" (click)="verLote(p.lote)">{{ p.lote }}</button>
              · ref. <span class="kb-td-mono">{{ p.referencia }}</span></p>
          </div>
          <div class="flex flex-wrap gap-2" *ngIf="puedePreparar && descartando !== p.code">
            <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" (click)="resolverTrasAnular(p, 'REGISTRAR')" [disabled]="ocupado || p.estado_actual === 'PAGADA'">Registrar el pago</button>
            <button type="button" class="kb-btn kb-btn-outline" (click)="descartando = p.code; motivoDescartar = ''">Descartar</button>
          </div>
        </div>
        <div class="kb-cinta !m-0" *ngIf="p.pago_doble" role="alert">
          <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
          <span class="min-w-0"><strong class="font-medium">Posible pago doble.</strong>
            <ng-container *ngIf="p.estado_actual === 'PAGADA'"> Esta cuenta por pagar ya se pagó por otro lote: pide el reverso al banco y descarta este pago.</ng-container>
            <ng-container *ngIf="p.estado_actual === 'EN_LOTE'"> Está otra vez en el lote {{ p.lote_actual }}. Si ese lote no se envió, al registrar este pago sale de él; si ya se envió, pide anularlo primero.</ng-container></span>
        </div>
        <div class="flex flex-wrap items-end gap-2" *ngIf="descartando === p.code">
          <label class="kb-label" [for]="'desc-' + p.code">Motivo para descartar
            <input type="text" class="kb-input !w-full sm:!w-[360px]" [id]="'desc-' + p.code" [(ngModel)]="motivoDescartar" maxlength="200" placeholder="Por ejemplo: el banco reversó la transferencia">
          </label>
          <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90 kb-btn-sm" (click)="resolverTrasAnular(p, 'DESCARTAR')" [disabled]="ocupado">Descartar</button>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="descartando = null; motivoDescartar = ''">Cancelar</button>
        </div>
      </div>
    </div>
  </section>

  <section class="kb-card" *ngIf="noProcesados.length">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-tools text-muted-foreground" aria-hidden="true"></i>Por resolver · {{ noProcesados.length }}</h2>
        <p class="kb-card-desc">Resuelve con el comercio y arma una propuesta nueva (sigue las bandas por su monto), o retén el pago con su motivo. Con la cuenta del comercio sin verificar solo se puede retener.</p>
      </div>
    </div>
    <div class="kb-table-envoltorio">
      <table class="kb-table">
        <thead class="kb-thead"><tr>
          <th class="kb-th kb-th-elegir"><span class="sr-only">Marcar</span></th>
          <th class="kb-th">Cuenta por pagar</th><th class="kb-th">Comercio</th><th class="kb-th kb-th-num">USD</th>
          <th class="kb-th">Motivo del banco</th><th class="kb-th kb-th-num">Intentos</th><th class="kb-th">Cuenta del comercio</th>
        </tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let p of noProcesados" [class.kb-tr-elegida]="marcadas.has(p.code)">
            <td class="kb-td"><input type="checkbox" [id]="'np-' + p.code" [checked]="marcadas.has(p.code)" (change)="marcar(p)" [disabled]="!puedePreparar"
              [attr.aria-label]="'Marcar ' + p.code"></td>
            <td class="kb-td"><span class="kb-td-titulo kb-td-mono">{{ p.code }}</span>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm !w-auto !px-0 kb-td-sub" *ngIf="p.lote" (click)="verLote(p.lote)">{{ p.lote }}</button></td>
            <td class="kb-td"><app-estampa-comercio [codigo]="p.merchant_code" [conNombre]="true"></app-estampa-comercio></td>
            <td class="kb-td kb-td-num font-semibold">{{ p.monto | number:'1.2-2':'es' }}</td>
            <td class="kb-td">{{ p.motivo }}<span class="kb-td-sub block" *ngIf="p.de_la_cuenta">de la cuenta del comercio</span>
              <span class="kb-td-sub block" *ngIf="p.retenida_antes">retenido antes: {{ p.retenida_antes.motivo }}</span></td>
            <td class="kb-td kb-td-num">{{ p.intentos }}</td>
            <td class="kb-td">
              <span class="kb-badge kb-badge-exito" *ngIf="p.cuenta_lista">Verificada</span>
              <ng-container *ngIf="!p.cuenta_lista"><span class="kb-badge kb-badge-alerta">No lista</span><span class="kb-td-sub block">{{ p.cuenta_motivo }} · solo retener</span></ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="kb-card-footer flex flex-wrap items-end gap-3" *ngIf="puedePreparar">
      <p class="m-0 text-sm text-muted-foreground mr-auto">{{ marcadas.size }} marcado(s) · $ {{ monto | number:'1.2-2':'es' }}</p>
      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" (click)="proponer()" [disabled]="ocupado || !marcadas.size || !todasConCuenta"
        [title]="todasConCuenta ? '' : 'Hay pagos con la cuenta sin verificar: solo se pueden retener'">Propuesta nueva</button>
      <button type="button" class="kb-btn kb-btn-outline" *ngIf="!reteniendo" (click)="reteniendo = true" [disabled]="!marcadas.size">Retener</button>
      <ng-container *ngIf="reteniendo">
        <label class="kb-label" for="motivoRetener">Motivo para retener
          <input type="text" class="kb-input !w-[300px]" id="motivoRetener" [(ngModel)]="motivoRetener" maxlength="200" placeholder="Por ejemplo: esperando la cuenta nueva">
        </label>
        <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90 kb-btn-sm" (click)="retener()" [disabled]="ocupado">Retener {{ marcadas.size }}</button>
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="reteniendo = false; motivoRetener = ''">Cancelar</button>
      </ng-container>
    </div>
  </section>
</div>
